export const getDistributionsBaseUrl = ({accountSlug, projectSlug, taskSlug } ) => {
    return taskSlug ?`/accounts/${accountSlug}/${projectSlug}/${taskSlug}`
        : `/accounts/${accountSlug}/${projectSlug}`;
};

const distributionsApi = ($axios) => {
    return {
        createDistribution({path, payload}){
            const {accountSlug, projectSlug, taskSlug } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions`;
            return $axios.post(url, payload);
        },
        getDistributions({path, query}) {
            const {accountSlug, projectSlug, taskSlug } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions`;
            return $axios.get(url, {params: {...query}});
        },
        updateDistribution({path, payload, config}) {
            const {accountSlug, projectSlug, taskSlug, distributionId } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}`;
            return $axios.post(url, payload, config);
        },
        deleteDistribution({path}) {
            const {accountSlug, projectSlug, taskSlug, distributionId } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}`;
            return $axios.delete(url);
        },
        disableDistributionCurrentBatchUser({path, payload}) {
            const {accountSlug, projectSlug, taskSlug, distributionId, distributionUserId } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}/users/${distributionUserId}`;
            return $axios.delete(url, payload);
        },
        getPreviousBatch({path}){
            const {accountSlug, projectSlug, taskSlug, distributionId, distributionBatchId } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}/batches/${distributionBatchId}`;
            return $axios.get(url);
        },
        deleteBatch({path}){
            const {accountSlug, projectSlug, taskSlug, distributionId, distributionBatchId } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}/batches/${distributionBatchId}`;
            return $axios.delete(url);
        },
        getPreviousBatchUsers({path, query}){
            const {accountSlug, projectSlug, taskSlug, distributionId, distributionBatchId } = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}/batches/${distributionBatchId}/users`;
            return $axios.get(url, query);
        },
        sendBatch({path, payload}){
            const {accountSlug, projectSlug, taskSlug, distributionId, distributionBatchId} = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}/batches/${distributionBatchId}`;
            return $axios.put(url, payload);
        },
        sendPreview({path, payload}){
            const {accountSlug, projectSlug, taskSlug, distributionId} = path;
            const baseUrl = getDistributionsBaseUrl({accountSlug, projectSlug, taskSlug });
            const url = `${baseUrl}/distributions/${distributionId}/send-test/email`;
            return $axios.post(url, payload);
        }
    };
};

export default distributionsApi;